import { useEffect } from "react";
import { useSelector } from "react-redux";
import loadable from "@loadable/component";
import clearModalData from "core-web/state/models/Modal/dispatches/clearModalData";
import hideModal from "core-web/state/models/Modal/dispatches/hideModal";
import showModalError from "core-web/state/models/Modal/dispatches/showModalError";
import { allowScroll, preventScroll } from "core-web/utils/scrollFunctions";
import ModalWrapper from "./ModalWrapper";

const avalibleModals = {
    promotionModal: loadable(() => import("theme/components/Modal/modalComponents/PromotionModal")),
};

const Modal = () => {
    const { theme, data, show } = useSelector(({ modal }) => modal) ?? {};

    const hasCurrentType = !!avalibleModals[theme];
    const Render = hasCurrentType && avalibleModals[theme];

    const handleClose = () => {
        hideModal();

        // Clear data after animation is done to prevent height jumping
        setTimeout(() => {
            clearModalData();
        }, 250);
    };

    useEffect(() => {
        if (hasCurrentType && show) {
            preventScroll();
        } else if (!hasCurrentType && show) {
            showModalError();
        } else {
            allowScroll();
        }
    }, [hasCurrentType, show]);

    return (
        <ModalWrapper show={hasCurrentType && show} handleClose={handleClose}>
            {hasCurrentType ? <Render data={data} /> : null}
        </ModalWrapper>
    );
};

export default Modal;
